<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/yge8q4/tc-custom/9781488087875.jpg?1702092118113" alt="This image is the cover for the book Texas Ranger Showdown, Lone Star Justice"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Texas Ranger Showdown, Lone Star Justice
      </h1>
      <p class="bookDescription body article font2">
        <b>When a radio therapist is taunted by a killer, she turns to the Texas Ranger she once loved in the <i>USA Today</i>–bestselling author’s romantic suspense novel.</b><br/><br/>Between her private practice and her Texas radio call-in show, Dr. Caitlyn Rhodes has built a successful career as a therapist. But when a methodical murderer starts targeting her clients, her worlds starts to come apart. Then the mocking phone calls start. <br/><br/>Someone very dangerous is tormenting Caitlyn, and the evidence is pointing Texas Ranger Ian Pierce to one chilling conclusion. He must protect Caitlyn from becoming this vicious killer’s next victim . . . before he loses the woman he once loved—for good.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Margaret Daley
      </h2>
      
      <p class="authorDescription body article">Margaret Daley, an award-winning author of eighty-three books, has been married for over forty years and is a firm believer in romance and love. When she isn&rsquo;t traveling, she&rsquo;s writing love stories, often with a suspense thread, and corralling her three cats that think they rule her household. To find out more about Margaret visit her website at http://www.margaretdaley.com.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?d1eb4334